import React from 'react';
import './Contact.css';
import GoogleMap from './GoogleMap/GoogleMap';

const Contact = (props) => {
	const ContactData = props.contact.map(data => {
		const stripedString = data.title.rendered.replace("#038;", "");
		return (
			<div className="contact_text" key={data.id}>
				<h2>{stripedString}</h2>
				<div dangerouslySetInnerHTML={{ __html: data.acf.info }}></div>
			</div>
		)
	});
	return (
		<section>
			<div className='map'>
				<GoogleMap contact={props.contact} />
			</div>
			{ContactData}
		</section>
	)
}


export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js